import { gql } from '@/Types/gql';

export const CREATE_SESSION = gql(`mutation CreateSession($data: CreateSessionInput!) {
  createSession(data: $data) {
    _id
  }
}`);

export const UPDATE_SESSION = gql(`mutation UpdateSession($data: UpdateSessionInput!) {
    updateSession(data: $data) {
    _id
  }
}`);
